import { MustScreen } from "app/screens/residents/show/MustScreen";

export default function MustPage() {
  return <MustScreen />;
}
